import React from 'react';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import addMonths from 'date-fns/add_months';
import subMonths from 'date-fns/sub_months';
import { Box } from 'grid-styled';
import { string, bool, func } from 'prop-types';
import MonthYearPicker from './MonthYearPicker';
import { getInterval, intervalToArray } from '../utils/time';

const MonthYearRange = ({ selected, yearsOnly, bounds, onChange }) => {
  const [startSelected, endSelected] = intervalToArray(selected);
  const [, endBounds] = intervalToArray(bounds);

  const end = isAfter(endSelected, endBounds)
    ? subMonths(endBounds, 1)
    : endSelected;
  const start = isAfter(startSelected, end) ? subMonths(end, 1) : startSelected;

  return (
    <Box>
      <MonthYearPicker
        title="From"
        selected={start}
        bounds={bounds}
        yearsOnly={yearsOnly}
        onChange={newStart =>
          isAfter(newStart, end)
            ? onChange(
                getInterval(newStart, addMonths(newStart, yearsOnly ? 11 : 1)),
              )
            : onChange(getInterval(newStart, end))
        }
      />
      <MonthYearPicker
        title="To"
        selected={end}
        bounds={bounds}
        yearsOnly={yearsOnly}
        onChange={newEnd =>
          isBefore(newEnd, start)
            ? onChange(
                getInterval(subMonths(newEnd, yearsOnly ? 11 : 1), newEnd),
              )
            : onChange(getInterval(start, newEnd))
        }
      />
    </Box>
  );
};

MonthYearRange.propTypes = {
  selected: string,
  bounds: string,
  yearsOnly: bool,
  onChange: func,
};

export default MonthYearRange;



// WEBPACK FOOTER //
// ./src/components/MonthYearRange.jsx